module.exports = __webpack_public_path__ + "img/missionaries5_2019_7-7-2021.5e10a187.jpg";